// Copyright (c) 2020-2021 Visual Intelligence LP. All rights reserved.
//
import * as React from 'react';
import { CircularProgress, CircularProgressProps, alpha } from '@mui/material';
import { withStyles } from "tss-react/mui";
import cx from 'classnames';

export interface LoadingProps {
  className?: string;
  classes?: any;
  margin?: 'none' | 'small' | 'normal' | 'big';
  progressProps?: CircularProgressProps;
  absolute?: boolean;
  children?: number[]; // This is a hack to force re-rendering
}

const Loading: React.FunctionComponent<LoadingProps> = (props): JSX.Element => {
  const { margin = 'none', progressProps, absolute } = props;
  const classes = withStyles.getClasses(props);

  return (
    <div className={cx(classes.root, classes[margin], { [classes.rootAbsolute]: absolute } )}>
      <CircularProgress size={40} classes={{ svg: classes.svg }} {...progressProps} />
    </div>
  );
};

const LoadingStyled = withStyles(
  Loading, 
  (theme, props) => ({
    "root": {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100%',
    },
    "rootAbsolute": {
      position: 'absolute',
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      zIndex: 3,
      backgroundColor: alpha('#fff', .5)
    },
    "none": {
      margin: 0,
    },
    "small": {
      margin: theme.spacing(2),
    },
    "normal": {
      margin: theme.spacing(4),
    },
    "big": {
      margin: theme.spacing(6),
    },
    "svg": {},
  })
);

export default LoadingStyled;